import { Box, styled } from '@material-ui/core';

export const RowContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
});

export const FirstRowBox = styled(Box)({
  height: 86,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

export const SecondRowBox = styled(Box)(
  ({ hasNote }: { hasNote?: boolean }) => ({
    minHeight: hasNote ? 36 : 20,
    height: 'auto'
  })
);
